document.addEventListener('change', function (event) {
  const variantRadios = event.target.closest('form[action*="/cart/add"]');
  if (!variantRadios) return;

  const variantInput = variantRadios.querySelector('input[name="id"]');
  if (!variantInput) return;

  const variantId = variantInput.value;

  fetch(`${window.location.pathname}.js`)
    .then(res => res.json())
    .then(product => {
      const variant = product.variants.find(v => v.id == variantId);
      if (!variant) return;

      const priceWrapper = document.querySelector('.price-wrapper');
      if (!priceWrapper) return;

      const salePriceEl = priceWrapper.querySelector('.sale-price');
      const compareEl = priceWrapper.querySelector('.compare s');
      const discountEl = priceWrapper.querySelector('.discount');

      // Format price
      const formatMoney = (cents) =>
        `₹ ${(cents / 100).toLocaleString('en-IN')}`;

      // Update sale price
      if (salePriceEl) {
        salePriceEl.textContent = formatMoney(variant.price);
      }

      // Update compare + discount
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        const discountPercent = Math.round(
          ((variant.compare_at_price - variant.price) * 100) /
          variant.compare_at_price
        );

        if (compareEl) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
        }

        if (discountEl) {
          discountEl.textContent = `(${discountPercent}% OFF)`;
        }
      } else {
        if (compareEl) compareEl.textContent = '';
        if (discountEl) discountEl.textContent = '';
      }
    });
});
